import styled from 'styled-components'

export const AccordionSummaryTexts = styled.div`
  display: flex;
  flex-direction: column;

  > :last-child {
    margin-top: 10px;
  }
`

export const Attributes = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  gap: 15px;
`

export const ListItem = styled.li`
  list-style-type: none;
`
